import React from 'react';
import * as _ from 'lodash';
import MarkerClusterer from './markerClusterer';
import markerIcon from 'assets/images/chart.png';
import markerIconBlue from 'assets/images/chart-blue.png';

export default class Map extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ports: [],
            childs: [],
        };

        this.showMarkerInfo = this.showMarkerInfo.bind(this);

        this.drawingManager = undefined;
        this.polygons = [];

        this.DMforDeletePolygon = undefined;
        this.polygonForDelete = undefined;

        this.markerClusterer = undefined;
    }

    showMarkerInfo(port) {
        this.props.togglePort(port);
    }

    addMarkerClusterToMap(ports) {
        const markers = [];
        this.markers = new window.Map();

        if (this.markerClusterer) {
            this.markerClusterer.clearMarkers();
        }

        const portsLenght = ports.length;

        for (let i = 0; i < portsLenght; i++) {
            if (ports[i].coordinates) {
                const marker = new google.maps.Marker({
                    position: {
                        lat: ports[i].coordinates[1],
                        lng: ports[i].coordinates[0],
                    },
                    icon: {
                        labelOrigin: new google.maps.Point(11, 50),
                        url: markerIcon,
                        size: new google.maps.Size(22, 40),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(11, 40),
                    },
                    title: 'noSelected',
                    label: {
                        color: 'black',
                        fontWeight: 'bold',
                        text: ports[i].name,
                    },
                });

                google.maps.event.addListener(marker, 'click', () => {
                    this.showMarkerInfo(ports[i]);
                });

                this.markers.set(ports[i]._id, marker);
                markers.push(marker);
            }
        }

        const opt = {
            legend: {
                noSelected: '#9dffa1',
                selected: '#0000ff',
            },
        };

        this.markerClusterer = new MarkerClusterer(this.map, markers, opt);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const isSameArea = nextProps.area._id === this.props.area._id;

        if (nextProps.showMarkersOnlyInThisArea && !isSameArea
            || nextProps.ports.items.length !== this.props.ports.items.length) {
            this.addMarkerClusterToMap(nextProps.ports.items);
        }

        
        this.colorizeMarkers(nextProps);
        
        const childs = [];
        
        for (let value of nextProps.area.childs) {
            childs.push(value);
        }
        
        if (this.markerClusterer && !_.isEqual(childs, this.state.childs)) {
            this.markerClusterer.repaint();
        }

        this.setState({
            ports: nextProps.ports.items,
            childs,
        });
    }

    colorizeMarkers(nextProps) {
        for (const port of nextProps.ports.items) {
            const marker = this.markers.get(port._id);

            if (marker
                && marker.getLabel().color === 'blue'
                && !nextProps.area.childs.has(port._id)) {
                marker && marker.setLabel({
                    ...marker.getLabel(),
                    color: 'black',
                });

                marker && marker.setIcon({
                    ...marker.getIcon(),
                    url: markerIcon,
                });

                marker.title = 'noSelected';
            }

            if (nextProps.area.childs.has(port._id)) {
                marker && marker.setLabel({
                    ...marker.getLabel(),
                    color: 'blue',
                });

                marker && marker.setIcon({
                    ...marker.getIcon(),
                    url: markerIconBlue,
                });

                marker.title = 'selected';
            }
        }
    }

    updateAreaDataStorage() {
        this.props.onAreaPathReady(this.polygons.map(p => p.getPath()));
    }

    componentDidMount() {
        this.map = new google.maps.Map(this.refs.map, {
            zoom: 2,
            center: {
                lat: 49.171839,
                lng: 10.433250,
            },
            gestureHandling: 'greedy',
            styles: [{
                featureType: 'administrative.locality',
                elementType: 'labels',
                stylers: [
                    { visibility: 'off' },
                ],
            }],
        });

        window.mainMap = this.map;
    }

    componentDidUpdate(prevProps) {
        if (!this.map) {
            return;
        }

        if (!google.maps) {
            return;
        }

        if (this.props.area.showPortOnMap) {
            const currentPort = this.props.ports.items.filter((port) => this.props.area.showPortOnMap === port._id);

            this.map.setCenter(this.toLatLng([currentPort[0].coordinates])[0]);
            this.map.setZoom(10);
        }

        const isSameArea = this.props.area._id === prevProps.area._id;
        const shapeEquals = _.isEqual(this.props.area.areaCoordinatesPolygons, prevProps.area.areaCoordinatesPolygons);
        const markersChanged = prevProps.showMarkersOnlyInThisArea !== this.props.showMarkersOnlyInThisArea;

        if (isSameArea && shapeEquals && !markersChanged && (this.drawingManager || this.polygons.length > 0)) {
            return;
        }

        if (this.drawingManager) {
            this.clearDrawingManager();
        }

        this.setupDrawingManager();

        this.removePolygon();

        this.setBoundsCoordinates();
        this.drawAreas();
        this.checkIsNewArea();
        this.createDeletePolygon();
    }

    setBoundsCoordinates() {
        const areasPorts = this.props.ports.items.filter((port) => {
            if (this.props.area.childs.has(port._id)) {
                return port;
            }
        });

        if (areasPorts.length > 0) {
            const coords = this.toLatLng(areasPorts.map(port => port.coordinates));
    
            if (coords.length === 1) {
                this.map.setCenter(coords[0]);
                this.map.setZoom(10);
            } else {
                this.fitBounds(coords);
            }
        }
        else {
            this.polyFitBounds(this.props.area.areaCoordinatesPolygons);
        }
    }

    polyFitBounds(multiPolygon) {
        if (!multiPolygon || !Array.isArray(multiPolygon.coordinates)) {
            return;
        }

        var bounds = new google.maps.LatLngBounds();

        for (const polygon of multiPolygon.coordinates) {
            let curr = new google.maps.LatLngBounds();

            // we only use outer polygon to calculate bounds
            // because inner paths must be enclosed in it
            for (const point of this.toLatLng(polygon[0])) {
                curr.extend(point);
            }

            bounds.union(curr);
        }

        if (bounds.isEmpty()) {
            return;
        }

        this.map.fitBounds(bounds);
    }

    clearDrawingManager() {
        this.drawingManager.setMap(null);

        google.maps.event.clearInstanceListeners(this.drawingManager);

        this.drawingManager = undefined;
    }

    drawAreas() {
        const multiPolygons = this.props.area.areaCoordinatesPolygons.coordinates;
        if (!multiPolygons) return;
        for (const polCoords of multiPolygons) {
            if (this.hasValidPolygon(polCoords[0])) {
                const coords = this.toLatLng(polCoords[0]);
    
                const polygon = new google.maps.Polygon({
                    paths: coords,
                    strokeColor: '#00f',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#00f',
                    fillOpacity: 0.35,
                    editable: true,
                    draggable: true
                });
    
                polygon.setMap(this.map);
                this.handlePolygon(polygon);
            }
        }
    }

    checkIsNewArea() {
        if (this.props.area.isNew) {
            if (!(this.polygonForDelete && this.DMforDeletePolygon)) {
                return;
            }

            this.DMforDeletePolygon.setMap(null);
            this.polygonForDelete.setMap(null);

            google.maps.event.clearInstanceListeners(this.polygonForDelete);

            this.polygonForDelete = undefined;

            return;
        }
    }

    setupDrawingManager() {
        if (this.drawingManager) {
            return;
        }
        this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: ['polygon']
            },
            polygonOptions: {
                editable: true,
                fillColor: '#00f',
                strokeColor: '#00f',
            }
        });

        google.maps.event.addListener(this.drawingManager, 'polygoncomplete', (polygon) => {
            this.handlePolygon(polygon);
        });

        this.drawingManager.setMap(this.map);
    }

    createDeletePolygon() {
        const self = this;
        const checkbox = new Checkbox();
        const label = new Label();
        const parentControl = new ParentControl();

        parentControl.appendChild(label);
        parentControl.appendChild(checkbox);

        checkbox.addEventListener('change', (e) => {
            if (!e.target.checked) {
                self.DMforDeletePolygon.setMap(null);

                if (!self.polygonForDelete) {
                    return;
                }

                self.polygonForDelete.setMap(null);
                google.maps.event.clearInstanceListeners(self.polygonForDelete);
                self.polygonForDelete = undefined;
                self.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].removeAt(1);

                return;
            }

            this.DMforDeletePolygon = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYGON,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.BOTTOM_CENTER,
                    drawingModes: ['polygon']
                },
                polygonOptions: {
                    editable: true,
                    fillColor: '#f00',
                    strokeColor: '#f00',
                }
            });

            google.maps.event.addListener(self.DMforDeletePolygon, 'polygoncomplete', (polygon) => {
                const parentControl = new ParentControl();
                const buttonDelete = new ButtonDelete();

                self.polygonForDelete = polygon;

                self.polygonForDelete.setEditable(true);
                self.polygonForDelete.setDraggable(true);

                parentControl.appendChild(buttonDelete);
                self.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(parentControl);

                buttonDelete.addEventListener('click', () => {
                    const items = self.state.ports.filter((port) => {
                        return self.props.area.childs.has(port._id);
                    });

                    self.itemsToDelete = items.filter((item) => {
                        return google.maps.geometry.poly.containsLocation(
                            new google.maps.LatLng(item.coordinates[1], item.coordinates[0]), self.polygonForDelete);
                    });

                    self.props.togglePort(self.itemsToDelete);

                    checkbox.checked = false;

                    self.DMforDeletePolygon.setMap(null);
                    self.polygonForDelete.setMap(null);

                    google.maps.event.clearInstanceListeners(self.polygonForDelete);
                    self.polygonForDelete = undefined;

                    self.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].removeAt(1);
                });

                this.DMforDeletePolygon.setMap(null);
            });

            this.DMforDeletePolygon.setMap(self.map);
        });

        this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].clear();
        this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(parentControl);
    }

    fitBounds(coords) {
        let bounds = new google.maps.LatLngBounds();

        for (const point of coords) {
            bounds.extend(point);
        }

        this.map.fitBounds(bounds);
    }

    removePolygon(only) {
        let toRemove = this.polygons;
        if (Array.isArray(only)) {
            toRemove = this.polygons.filter(p => only.includes(p));
        }
        for (const polygon of toRemove) {
            polygon.setMap(null);
            google.maps.event.clearInstanceListeners(polygon);
        }
        this.polygons = this.polygons.filter(p => !toRemove.includes(p));
    }

    hasValidPolygon(polygon) {
        return polygon && polygon.length >= 3;
    }

    handlePolygon(polygon) {
        this.polygons.push(polygon);

        const path = polygon.getPath();
        this.updateAreaDataStorage();

        let deleteMenu = buildDeleteBtn();
        let deletePolygon = buildDeletePolygon();

        const clean = () => {
            this.removePolygon([polygon]);
            this.updateAreaDataStorage();
        }

        google.maps.event.addListener(path, 'remove_at', (...args) => {
            if (path.getLength() < 3) {
                clean();
            }
        });

        google.maps.event.addListener(polygon, 'rightclick', (e) => {
            // Check if click was on a vertex control point
            if (e.vertex != undefined) {
                return deleteMenu.open(this.map, polygon.getPath(), e.vertex);
            }

            deletePolygon.open(
                this.map,
                polygon,
                e,
                clean,
            );
        });
    }

    toLatLng(array) {
        return array.map(point => ({ lng: point[0], lat: point[1] }));
    }

    render() {
        return (
            <div ref='map' style={{ height: '75vh' }}></div>
        );
    }
}

function Checkbox() {
    const checkbox = document.createElement('input');

    checkbox.type = 'checkbox';
    checkbox.id = 'remove-ports';

    checkbox.style.display = 'inlineBlock';
    checkbox.style.width = '15px';
    checkbox.style.height = '15px';
    checkbox.style.cursor = 'pointer';

    return checkbox;
}

function Label() {
    const label = document.createElement('label');

    label.htmlFor = 'remove-ports';
    label.innerHTML = 'Remove ports';

    label.style.fontSize = '18px';
    label.style.marginRight = '10px';
    label.style.display = 'inlineBlock';
    label.style.cursor = 'pointer';

    return label;
}

function ButtonDelete(text = 'DELETE PORTS') {
    const button = document.createElement('button');

    button.style.backgroundColor = '#fff';
    button.style.fontSize = '16px';
    button.innerHTML = text;

    return button;
}

function ParentControl() {
    const controlDiv = document.createElement('div');

    controlDiv.type = 'checkbox';
    controlDiv.id = 'parent-block-remove-ports';

    controlDiv.style.backgroundColor = '#fff';
    controlDiv.style.width = '160px';
    controlDiv.style.height = '24px';
    controlDiv.style.marginBottom = '5px';
    controlDiv.style.padding = '10px';
    controlDiv.style.display = 'flex';
    controlDiv.style.justifyContent = 'center';
    controlDiv.style.alignItems = 'center';

    return controlDiv;
}

function buildDeleteBtn() {
    function DeleteMenu() {
        this.div_ = document.createElement('div');
        this.div_.className = 'delete-menu';
        this.div_.innerHTML = 'Delete';

        let menu = this;

        google.maps.event.addDomListener(this.div_, 'click', function () {
            menu.removeVertex();
        });
    }

    DeleteMenu.prototype = new google.maps.OverlayView();

    DeleteMenu.prototype.onAdd = function () {
        let deleteMenu = this;
        let map = this.getMap();
        this.getPanes().floatPane.appendChild(this.div_);

        // mousedown anywhere on the map except on the menu div will close the
        // menu.
        this.divListener_ = google.maps.event.addDomListener(map.getDiv(), 'mousedown', function (e) {
            if (e.target != deleteMenu.div_) {
                deleteMenu.close();
            }
        }, true);
    };

    DeleteMenu.prototype.onRemove = function () {
        google.maps.event.removeListener(this.divListener_);
        this.div_.parentNode.removeChild(this.div_);

        // clean up
        this.set('position');
        this.set('path');
        this.set('vertex');
    };

    DeleteMenu.prototype.close = function () {
        this.setMap(null);
    };

    DeleteMenu.prototype.draw = function () {
        let position = this.get('position');
        let projection = this.getProjection();

        if (!(position && projection)) {
            return;
        }

        let point = projection.fromLatLngToDivPixel(position);
        this.div_.style.top = point.y + 'px';
        this.div_.style.left = point.x + 'px';
    };

    /**
     * Opens the menu at a vertex of a given path.
     */
    DeleteMenu.prototype.open = function (map, path, vertex) {
        this.set('position', path.getAt(vertex));
        this.set('path', path);
        this.set('vertex', vertex);
        this.setMap(map);
        this.draw();
    };

    /**
     * Deletes the vertex from the path.
     */
    DeleteMenu.prototype.removeVertex = function () {
        let path = this.get('path');
        let vertex = this.get('vertex');

        if (!path || vertex == undefined) {
            this.close();
            return;
        }

        path.removeAt(vertex);
        this.close();
    };


    return new DeleteMenu();
}

function buildDeletePolygon() {
    function deletePolygonBtn() {
        this.div_ = document.createElement('div');
        this.div_.className = 'delete-menu';
        this.div_.innerHTML = 'Delete polygon';

        let self = this;

        google.maps.event.addDomListener(this.div_, 'click', function () {
            self.removeCurrentPolygon();
        });
    }

    deletePolygonBtn.prototype = new google.maps.OverlayView();

    deletePolygonBtn.prototype.removeCurrentPolygon = function() {
        this.get('onClick')();

        this.close();
    };

    deletePolygonBtn.prototype.onAdd = function () {
        let deleteMenu = this;
        let map = this.getMap();
        this.getPanes().floatPane.appendChild(this.div_);

        this.divListener_ = google.maps.event.addDomListener(map.getDiv(), 'mousedown', function (e) {
            if (e.target != deleteMenu.div_) {
                deleteMenu.close();
            }
        }, true);
    };

    deletePolygonBtn.prototype.onRemove = function () {
        google.maps.event.removeListener(this.divListener_);
        this.div_.parentNode.removeChild(this.div_);

        // clean up
        this.set('position');
        this.set('polygon');
        this.set('onClick');
    };

    deletePolygonBtn.prototype.open = function(map, polygon, event, onClick) {
        this.set('position', event.latLng);
        this.set('polygon', polygon);
        this.set('onClick', onClick);

        this.setMap(map);
        this.draw();
    };

    deletePolygonBtn.prototype.close = function() {
        this.setMap(null);
    };

    deletePolygonBtn.prototype.draw = function() {
        let position = this.get('position');
        let projection = this.getProjection();

        if (!position || !projection) {
            return;
        }

        let point = projection.fromLatLngToDivPixel(position);
        this.div_.style.top = point.y + 'px';
        this.div_.style.left = point.x + 'px';
    };

    return new deletePolygonBtn();
}



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Map/MapPorts.jsx